import {Base64DataSchema, ImageProcessingNodes} from "@cm/image-processing-nodes"
import {toBase64} from "@cm/browser-utils"
import {UploadGqlService} from "@common/services/upload/upload.gql.service"
import {z} from "zod"
import {Geometry} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/rasterize-geometry/definition"

export async function uploadGeometry(uploadService: UploadGqlService, organizationId: string, geometry: Geometry, filename = "geometry.json") {
    const positions = geometry.vertices.positions
    const uvs = geometry.vertices.uvs
    const indices = geometry.indices
    const mapToBase64 = (data: Float32Array | Uint32Array): z.infer<typeof Base64DataSchema> => {
        return {
            type: "base64",
            data: toBase64(data),
        }
    }
    const geometryBase64: ImageProcessingNodes.GeometryBase64 = {
        type: "geometry-base64",
        topology: "triangleList",
        vertices: {
            positions: mapToBase64(positions),
            uvs: uvs ? mapToBase64(uvs) : undefined,
        },
        indices: indices ? mapToBase64(indices) : undefined,
    }
    const contentType = "application/json"
    const file = new File([new Blob([JSON.stringify(geometryBase64)], {type: contentType})], filename, {type: contentType})
    return uploadService.createAndUploadDataObject(file, {organizationId: organizationId}, {showUploadToolbar: false, processUpload: false})
}
